// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SWwTpmRNPzGzyFWvdOu4{background:#e4f7fd;border:1px solid #024cbc;border-radius:5px;display:inline-flex;height:20px;overflow:hidden;width:92px}.SWwTpmRNPzGzyFWvdOu4._Pxvw1SIUB85yn2ERdTT div{background:#024cbc;border-color:#e4f7fd}.SWwTpmRNPzGzyFWvdOu4.bY2p7yUc2_Ny9aNh6no1 div:nth-of-type(1){background:#024cbc}.SWwTpmRNPzGzyFWvdOu4.GKr3EraOBqVksKquWtFU div:nth-of-type(1){background:#024cbc}.SWwTpmRNPzGzyFWvdOu4.GKr3EraOBqVksKquWtFU div:nth-of-type(2){background:#024cbc;border-left-color:#e4f7fd}.HGxUmCMi7h9AncWUqxe_{background:#e4f7fd;height:100%;width:30px}.HGxUmCMi7h9AncWUqxe_:nth-of-type(2){border-left:1px solid #024cbc;border-right:1px solid #024cbc}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `SWwTpmRNPzGzyFWvdOu4`,
	"fill3": `_Pxvw1SIUB85yn2ERdTT`,
	"fill1": `bY2p7yUc2_Ny9aNh6no1`,
	"fill2": `GKr3EraOBqVksKquWtFU`,
	"pillBox": `HGxUmCMi7h9AncWUqxe_`
};
module.exports = ___CSS_LOADER_EXPORT___;
